<template>
    <div>
        <el-tabs v-model="activeName">
            <el-tab-pane label="对冲统计" name="statics" v-if="rightsContains('HEDGE_MANAGE')">
                <el-card>
                    <div slot="header" class="clearfix">
                        <span>对冲失败 浮动盈亏统计</span>
                    </div>
                    <el-form :inline="true">
                        <el-form-item label="交易对"><el-input v-model="queryP.pair"></el-input></el-form-item>
                        <el-form-item label="状态">
                            <el-select v-model="queryP.status">
                                <el-option  v-for="item in statusType" :key="item.code" :label="item.desc" :value="item.code"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="失败原因" v-if="queryP.status === 'CREATE_FAILED'">
                            <el-select v-model="queryP.reason">
                                <el-option  v-for="item in reasonType" :key="item.code" :label="item.desc" :value="item.code"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-date-picker v-model="timeP" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp"  :picker-options="pickerOptions"></el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="queryProfit(1)">查询</el-button>
                            <el-button type="success" @click="openManual()">人工对冲</el-button>
                        </el-form-item>
                        <el-form-item label="市场浮动盈亏-总计：">{{profitLossTotal}}</el-form-item>
                    </el-form>

                    <el-table :data="profitAndLoss">
                        <el-table-column prop="pair" label="交易对"></el-table-column>
                        <el-table-column prop="orderType" label="买/卖"></el-table-column>
                        <el-table-column prop="amount" label="累计成交总额"></el-table-column>
                        <el-table-column prop="planAmount" label="若成功,花费USDT"></el-table-column>
                        <el-table-column prop="amountUsdt" label="最近整点市场金额USDT"></el-table-column>
                        <el-table-column prop="profitLoss" label="市场浮动盈亏(成功则盈利)"></el-table-column>
                        <el-table-column prop="orderNum" label="笔数"></el-table-column>
                        <el-table-column prop="price" label="价格(市价)"></el-table-column>
                    </el-table>
                    <el-pagination background layout="total,prev, pager, next" :total="countP" :page-size="15" :current-page="queryP.page"
                                   @current-change="queryProfit"></el-pagination>
                </el-card>

                <el-card>
                    <div slot="header" class="clearfix">
                        <span>对冲状态统计</span>
                    </div>
                    <el-form :inline="true">
                        <el-form-item label="交易对"><el-input v-model="queryHedge.pair"></el-input></el-form-item>
                        <el-form-item label="状态">
                            <el-select v-model="queryHedge.status">
                                <el-option  v-for="item in statusType" :key="item.code" :label="item.desc" :value="item.code"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="失败原因" v-if="queryHedge.status === 'CREATE_FAILED'">
                            <el-select v-model="queryHedge.reason">
                                <el-option  v-for="item in reasonType" :key="item.code" :label="item.desc" :value="item.code"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-date-picker v-model="timeHedge" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp" :picker-options="pickerOptions"></el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="queryHedgeRisk(1)">查询</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="exportHedgeStatistic()">导出当前对冲统计数据</el-button>
                        </el-form-item>
                    </el-form>
                    <el-table :data="hedge">
                        <el-table-column label="交易对" prop="pair"/>
                        <el-table-column label="交易所" prop="externalOrderSrc"/>
                        <el-table-column label="外部委托类型" prop="externalOrderType"/>
                        <el-table-column label="笔数" prop="orderNum"/>
                        <el-table-column label="成交总量" prop="totalAmt"/>
                        <el-table-column label="成交总值" prop="totalVal"/>
                        <el-table-column label="成交均价">
                            <template slot-scope="scope">
                                {{scope.row.totalVal/scope.row.totalAmt}}
                            </template>
                        </el-table-column>
                        <el-table-column label="外部委托均价" prop="externalAvgPrice"/>
                    </el-table>
                    <el-pagination background layout="total,prev, pager, next,sizes" :total="countHedge" :page-size="15" :current-page="queryHedge.page"
                                   :page-sizes="[15, 25, 35, 45]" @current-change="queryHedgeRisk" @size-change="handleSizeChange"></el-pagination>
                </el-card>

                <el-card>
                    <div slot="header" class="clearfix">
                        <span>对冲列表</span>
                    </div>
                    <el-form :inline="true">
                        <el-form-item label="交易对"><el-input v-model="queryOrder.pair"></el-input></el-form-item>
                        <el-form-item label="状态">
                            <el-select v-model="queryOrder.status">
                                <el-option  v-for="item in statusType" :key="item.code" :label="item.desc" :value="item.code"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="失败原因" v-if="queryOrder.status === 'CREATE_FAILED'">
                            <el-select v-model="queryOrder.reason">
                                <el-option  v-for="item in reasonType" :key="item.code" :label="item.desc" :value="item.code"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-date-picker v-model="orderTime" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp" :picker-options="pickerOptions"></el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="queryOrderList(1)">查询</el-button>
                        </el-form-item>
                    </el-form>
                    <el-table :data="orderList">
                        <el-table-column label="交易对" prop="pair"/>
                        <el-table-column label="成交价格" prop="price"/>
                        <el-table-column label="外部委托价格" prop="externalOrderPrice"/>
                        <el-table-column label="外部委托类型" prop="externalOrderType"/>
                        <el-table-column label="交易所" prop="externalOrderSrc"/>
                        <el-table-column label="已成交数量" prop="dealAmount"/>
                        <el-table-column label="外部委托上已经成交的量" prop="externalOrderDealAmt"/>
                        <el-table-column label="外部委托量" prop="externalOrderAmt"/>
                        <el-table-column label="外部委托状态" prop="externalOrderStatus">
                            <template slot-scope="scope">{{parseCodeToDesc(scope.row.externalOrderStatus,statusType)}}</template>
                        </el-table-column>
                        <el-table-column label="失败原因" prop="failType">
                            <template slot-scope="scope">{{parseCodeToDesc(scope.row.failType,reasonType)}}</template>
                        </el-table-column>
                        <el-table-column label="备注" prop="remark"/>
                        <el-table-column label="时间">
                            <template slot-scope="scope">{{parseDateTime(scope.row.createdTime)}}</template>
                        </el-table-column>
                    </el-table>
                    <el-pagination background layout="total,prev, pager, next" :total="countOrder" :page-size="15" :current-page="queryOrder.page"
                                   @current-change="queryOrderList"/>
                </el-card>
            </el-tab-pane>
            <el-tab-pane label="对冲策略" name="strategy" v-if="rightsContains('HEDGE_STRATEGY')">
                <hedge-strategy></hedge-strategy>
            </el-tab-pane>
        </el-tabs>

        <el-dialog title="手动对冲" :visible.sync="showManual" @close="closeManual()">
            <el-form label-width="120px">
                <el-form-item label="对冲数据">
                    <span>交易对：{{manual.pair}}&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <span>时间：{{parseDateTime(manual.startTime)}} / {{parseDateTime(manual.endTime)}}</span>
                    <span>&nbsp;&nbsp;&nbsp;&nbsp;失败原因：{{manual.reason}}</span>
                </el-form-item>
                <el-form-item label="下单方向">
                    <el-select v-model="manual.direction">
                        <el-option v-for="item in directionType" :label="item.desc" :key="item.code" :value="item.code"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="下单价">
                    <el-input v-model="manual.price"/>
                </el-form-item>
                <el-form-item label="下单量">
                    <el-input v-model="manual.amount"/>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="manual.remark"/>
                </el-form-item>
                <el-form-item>
                    <el-button type="info" @click="closeManual()">取消</el-button>
                    <el-button type="primary" @click="manualPair()">确认对冲</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

    </div>
</template>

<script>
    import api from './hedgeApi';
    import {RIGHTS_TYPE} from "../../common/constant";
    import {mapState} from "vuex";
    import HedgeStrategy from './HedgeStrategy';
    export default {
        name: "hedgeManage",
        components: {HedgeStrategy},
        data(){
            return {
                profitAndLoss: [],
                countP: 0,
                timeP:[],
                queryP:{
                    page: 1,
                    pair: '',
                    status: 'CREATE_FAILED',
                    reason: '',
                    startTime: '',
                    endTime: '',
                },
                hedge: [],
                countHedge: 0,
                timeHedge:[],
                queryHedge: {
                    page: 1,
                    pair: '',
                    status: 'CREATE_FAILED',
                    reason: '',
                    startTime: '',
                    endTime: '',
                    size: 15
                },
                statusType:[{code:'CREATE_FAILED',desc:'创建失败'},{code:'CANCELED',desc:'已取消'},{code:'MANNAUL_SUCC',desc:'手动对冲成功'},{code:'FILLED',desc:'已经成交完成'},{code:'PARTIALLY_FILLED',desc:'部分成交'},{code:'NEW',desc:'刚刚创建'},{code:'MANUAL_HEDGE_MERGE',desc: '手动对冲真实下单'}],
                orderList:[],
                countOrder:0,
                orderTime:[],
                queryOrder:{
                    page: 1,
                    pair: '',
                    status: 'CREATE_FAILED',
                    reason: '',
                    startTime: '',
                    endTime: '',
                },
                reasonType:[{code:'INSUFFICIENT_BALANCE',desc:'余额不足'},{code:'PARAM_ERROR',desc:'参数错误'},{code:'UNKNOWN',desc:'未知原因'},{code: 'GIVEUP',desc:'金额太小放弃'}],
                manual:{pair:'',remark:'',price:'',startTime:'',endTime:'',reason:'',amount:'',direction:''},
                profitLossTotal: 0,
                pickerOptions:{
                    shortcuts: [
                        {
                            text: '当天',
                            onClick(picker) {
                                const end = new Date();
                                let year=end.getFullYear();
                                let month=end.getMonth();
                                let date=end.getDate();
                                const start = new Date(year,month,date);
                                start.setTime(start.getTime());
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '最近三天',
                            onClick(picker) {
                                const end = new Date();
                                let year=end.getFullYear();
                                let month=end.getMonth();
                                let date=end.getDate();
                                const start = new Date(year,month,date);
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 2);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            let year=end.getFullYear();
                            let month=end.getMonth();
                            let date=end.getDate();
                            const start = new Date(year,month,date);
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
                            picker.$emit('pick', [start, end]);
                            }
                        },
                      ]
                },
                activeName:'statics',
                showManual: false,
                directionType:[{code:'ASK',desc:'卖出'},{code:'BID',desc:'买入'}]
            }
        },
        comments:{'HedgeStrategy':HedgeStrategy},
        computed: {
            ...mapState(["userInfo", "userRights"])
        },
        created() {
            if(this.rightsContains('HEDGE_MANAGE')){
               this. activeName = 'statics';
            }else {
                this. activeName = 'strategy';
            }
        },
        methods:{
            queryProfit(val){
                if (this.timeP.length !== 0){
                    this.queryP.startTime = this.timeP[0];
                    this.queryP.endTime = this.timeP[1];
                }
                this.queryP.page = val;
                api.queryProfitAndLossStatistic(this.queryP).then(response =>{
                    this.profitAndLoss = [];
                    this.countP = 0;
                    this.profitLossTotal = 0;
                    this.profitAndLoss = response.data.listInfo.list;
                    this.countP = response.data.listInfo.totalCount;
                    this.profitLossTotal = response.data.total;
                })
            },
            queryHedgeRisk(val){
                if (this.timeHedge.length !== 0){
                    this.queryHedge.startTime = this.timeHedge[0];
                    this.queryHedge.endTime = this.timeHedge[1];
                }
                this.queryHedge.page = val;
                api.queryHedgeStatistic(this.queryHedge).then(response =>{
                    this.hedge = [];
                    this.countHedge = 0;
                    this.hedge = response.data.list;
                    this.countHedge = response.data.totalCount;
                })
            },
            queryOrderList(val){
                if (this.orderTime.length !== 0){
                    this.queryOrder.startTime = this.orderTime[0];
                    this.queryOrder.endTime = this.orderTime[1];
                }
                this.queryOrder.page = val;
                api.queryOrderList(this.queryOrder).then(response =>{
                    this.orderList = [];
                    this.countOrder = 0;
                    this.orderList = response.data.list;
                    this.countOrder = response.data.totalCount;
                })
            },
            parseCodeToDesc(code,infos){
                for (let index in infos){
                    if (infos[index].code == code){
                        return infos[index].desc;
                    }
                }
            },
            parseDateTime(time){
                let now = new Date(time);
                let year=now.getFullYear();
                let month=now.getMonth()+1;
                let date=now.getDate();
                let hour=now.getHours();
                let minute=now.getMinutes();
                let second=now.getSeconds();
                return year+"-"+month+"-"+date+" "+hour+":"+minute+":"+second;
            },
            manualRiskHedge(info){
                this.$prompt('输入备注','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(({value}) =>{
                    api.manualRiskHedge({id:info.id,remark:value}).then(() =>{this.$message.success('操作成功');this.queryOrderList(1)});
                }).catch(() =>{this.$message.info('已取消')})
            },

            manualPair(){
                api.manualRiskHedge(this.manual).then(() =>{
                    this.$message.success('操作成功');
                    this.closeManual();
                    this.queryProfit(1);
                });
            },
            rightsContains(r) {
                let rights = this.userRights.split(",") || [];
                return rights.indexOf(RIGHTS_TYPE[r]) !== -1;
            },
            exportHedgeStatistic(){
                if (this.timeHedge.length !== 0){
                    this.queryHedge.startTime = this.timeHedge[0];
                    this.queryHedge.endTime = this.timeHedge[1];
                }
                api.exportHedgeStatistic(this.queryHedge).then(response =>{
                    const fileName = "对冲状态统计数据" + this.timeHedge[0] + "-" + this.timeHedge[1] + ".xlsx";
                    const blob = new Blob([response], {type: 'application/vnd.ms-excel'});
                    if ('download' in document.createElement('a')) {
                        const link = document.createElement('a');
                        link.download = fileName;
                        link.style.display = 'none';
                        link.href = URL.createObjectURL(blob);
                        document.body.appendChild(link);
                        link.click();
                        URL.revokeObjectURL(link.href);
                    } else {
                        navigator.msSaveBlob(blob, fileName);
                    }
                })
            },
            handleSizeChange(val) {
                this.queryHedge.size = val;
            },
            closeManual(){
                this.showManual = false;
                this.manual = {};
            },
            openManual(){
                if (!this.queryP.pair) {
                    this.$message.error('请输入对冲的交易对');
                    return;
                }
                if (this.queryP.status === 'CREATE_FAILED') {
                    this.manual.pair = this.queryP.pair;
                    this.manual.startTime = this.queryP.startTime;
                    this.manual.endTime = this.queryP.endTime;
                    this.manual.reason = this.queryP.reason;
                    this.showManual = true;
                }else {
                    this.$message.error('当前状态不需要对冲');
                }

            }
        }
    }
</script>

<style scoped>

</style>
